import React from "react";
import {Helmet} from 'react-helmet'

const PageHelmet = ({pageTitle = 'Not Found'}) => {
    return (
        <React.Fragment>
            <Helmet>
                <title>{pageTitle} | Zeodel Technologies Private Limited </title>
                <meta name="description" content="Zeodel Technologies Private Limited — a software company building web and mobile applications, business strategy, and reporting solutions for businesses."/>
            </Helmet>
        </React.Fragment>
    )
};

export default PageHelmet;
